const VILLAS = [
  {
    key: "villa-ananda",
    title: "Villa Ananda 5BHK",
    img: "/images/photo-tour/villa-ananda/pool",
    description: "12 guests | 5 bedrooms | 7 bathrooms",
    comingSoon: false,
    isNew: false,
    link: "/villas/villa-ananda",
  },
  {
    key: "villa-alaya",
    title: "Villa Alaya 5BHK",
    img: "/images/photo-tour/villa-alaya/pool1",
    description: "12 guests | 5 bedrooms | 5 bathrooms",
    comingSoon: false,
    isNew: false,
    link: "/villas/villa-alaya",
  },
  {
    key: "villa-etisha",
    title: "Villa Etisha 4BHK",
    img: "/images/photo-tour/villa-etisha/pool2",
    description: "10 guests | 4 bedrooms | 4 bathrooms",
    comingSoon: false,
    isNew: true,
    link: "/villas/villa-etisha",
  },
];

export default VILLAS;
